import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import {
  deleteError,
  deleteIndex,
  deleteIndexId,
  deleteSuccess,
  getIndices,
  saveIndex,
  setError,
  setIndex,
  setIndices
} from '../actions/indexdesigner.actions';
import { getLookUpTables } from '../actions/datamodel.actions';
import { ApplicationTypes } from 'src/app/services/util.enum';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class IndexDesignerEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private translate = inject(TranslateService);
  private store = inject(Store);
  private appGlobalService = inject(AppGlobalService);

  saveIndex = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveIndex),
        map((action) => {
          this.baseService[action.apiConstants?.method](action.apiConstants, action.indexObject).subscribe(
            (tableObject: any) => {
              if (tableObject) {
                this.store.dispatch(setIndex({ savedIndex: action.indexObject }));
                if (this.appGlobalService.get('applicationType') != ApplicationTypes.INDEPENDENT) {
                  this.store.dispatch(getLookUpTables({ apiConstants: ApiConstants.getLookUpTables }));
                }
              }
            },
            (err) => {
              this.store.dispatch(setError({ error: this.translate.instant(err?.error?.ERROR_CODE) }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  getIndices = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getIndices),
        map((action) => {
          this.baseService[action.getApiConstants?.method](action.getApiConstants, action.data).subscribe(
            (result: any) => {
              if (result) {
                this.store.dispatch(setIndices({ indices: result }));
              } else {
                this.store.dispatch(setIndices({ indices: [] }));
              }
            }
          );
        })
      ),
    { dispatch: false }
  );

  deleteIndex = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteIndex),
        map((action) => {
          this.baseService[action.apiConstants?.method](action.apiConstants, action.params).subscribe(
            (_index: any) => {
              this.store.dispatch(deleteSuccess({ deleteIndexId: action.params.indexId }));
              this.store.dispatch(deleteIndexId({ indexId: action.params.indexId }));
            },
            (err) => {
              this.store.dispatch(deleteError({ deleteError: err }));
            }
          );
        })
      ),
    { dispatch: false }
  );
}
